// Catálogo único de menus do sistema — usado pelo Sidebar (navegação) e pela
// tela Administrativo → Perfis de Usuário (checkboxes de permissão).
// Ao criar um menu/submenu novo, adicione AQUI: o Sidebar passa a exibi-lo e a
// tela de perfis ganha o checkbox automaticamente (perfis existentes precisam
// ser editados para liberar o novo item; admin vê tudo sempre).

export const ITENS_SIMPLES = [
  { id: 'dashboard',     to: '/dashboard',     label: 'Dashboard',     icon: '📊' },
  { id: 'relatorios',    to: '/relatorios',    label: 'Relatórios',    icon: '📈' },
  { id: 'assistente_ia', to: '/assistente-ia', label: 'Assistente IA', icon: '🤖' },
  { id: 'falar_suporte', to: '/falar-suporte', label: 'Falar com Suporte', icon: '💬' },
];

export const GRUPOS = [
  {
    id: 'estoque',
    label: 'Estoque',
    icon: '🏭',
    prefixo: ['/estoque'],
    filhos: [
      { to: '/estoque',             label: 'Estoque por Local', end: true },
      { to: '/estoque/manutencao',  label: 'Manutenção de Estoque' },
      { to: '/estoque/kardex',      label: 'Kardex' },
    ],
  },
  {
    id: 'vendas',
    label: 'Vendas',
    icon: '🛒',
    prefixo: ['/vendas'],
    filhos: [
      { to: '/vendas/pdv', label: 'PDV', novaAba: true },
      { to: '/vendas/pesagem', label: 'Pesagem/Etiquetas', novaAba: true },
      { to: '/vendas/pedidos', label: 'Pedidos/Orçamentos' },
      { to: '/vendas/devolucoes', label: 'Devoluções' },
      // Só aparece com Parâmetros → Vendas → "Habilitar recorrência" (Sidebar)
      { to: '/vendas/recorrencia', label: 'Gerar Recorrência' },
    ],
  },
  {
    id: 'agendamento',
    label: 'Agendamento',
    icon: '📅',
    prefixo: ['/agenda'],
    filhos: [
      { to: '/agenda', label: 'Agenda', end: true },
    ],
  },
  {
    id: 'compras',
    label: 'Compras',
    icon: '📦',
    prefixo: ['/compras'],
    filhos: [
      { to: '/compras/fornecedores',            label: 'Fornecedores',      end: true },
      { to: '/compras/fornecedores/cadastro',   label: 'Cad. Fornecedores' },
      { to: '/compras/entradas-nf',    label: 'Entrada de NF' },
      { to: '/compras/importacao-dfe', label: 'Importação DF-e' },
    ],
  },
  {
    id: 'produtos',
    label: 'Cad. Produtos',
    icon: '📦',
    prefixo: ['/produtos', '/tabelas-preco', '/produtos/alteracao-massa', '/produtos/grupos-marcas', '/catalogo-online', '/mercadopago', '/instagram'],
    filhos: [
      { to: '/produtos',                    label: 'Produtos',      end: true },
      { to: '/produtos/cadastro',           label: 'Cad. Produtos' },
      { to: '/tabelas-preco',               label: 'Tab. de Preço' },
      { to: '/produtos/alteracao-massa',    label: 'Alt. em Massa' },
      { to: '/produtos/grupos-marcas',      label: 'Grupos/Marcas' },
      { to: '/catalogo-online',             label: 'Catálogo Online' },
      { to: '/mercadopago',                 label: 'Mercado Pago' },
      { to: '/instagram',                   label: 'Instagram' },
    ],
  },
  {
    id: 'clientes',
    label: 'Cad. Clientes',
    icon: '👥',
    prefixo: ['/clientes', '/fidelidade'],
    filhos: [
      { to: '/clientes',            label: 'Clientes',      end: true },
      { to: '/clientes/cadastro',   label: 'Cad. Clientes' },
      { to: '/fidelidade',          label: 'Fidelidade' },
      { to: '/fidelidade/extrato',  label: 'Extrato de Pontos' },
      { to: '/fidelidade/resumo',   label: 'Resumo de Pontos' },
    ],
  },
  {
    id: 'financeiro',
    label: 'Financeiro',
    icon: '💰',
    prefixo: ['/financeiro'],
    filhos: [
      { to: '/financeiro/caixa',           label: 'Caixa / Fechamento' },
      { to: '/financeiro/transferencia',   label: 'Movimentações' },
      { to: '/financeiro/baixa-cartoes',   label: 'Baixa de Cartões' },
      { to: '/financeiro/contas-pagar',    label: 'Contas a Pagar' },
      { to: '/financeiro/contas-receber',  label: 'Contas a Receber' },
      { to: '/financeiro/contas',          label: 'Contas Financeiras' },
      { to: '/financeiro/bandeiras',       label: 'Bandeiras de Cartão' },
      { to: '/financeiro/plano-contas',    label: 'Plano de Contas' },
      { to: '/financeiro/dre',             label: 'DRE' },
    ],
  },
  {
    id: 'fiscal',
    label: 'Módulo Fiscal',
    icon: '🧾',
    prefixo: ['/fiscal'],
    filhos: [
      { to: '/fiscal/documentos', label: 'Central de Notas', end: true },
      { to: '/fiscal/nota-fiscal', label: 'Nota Fiscal' },
      { to: '/fiscal/mdfe/veiculos', label: 'Veículos e Condutores (MDF-e)' },
    ],
  },
  {
    id: 'admin',
    label: 'Administrativo',
    icon: '⚙️',
    prefixo: ['/admin'],
    filhos: [
      { to: '/admin/organizacoes',             label: 'Organizações', end: true },
      { to: '/admin/organizacoes/minha-empresa', label: 'Minha Empresa' },
      { to: '/admin/usuarios',                 label: 'Usuários' },
      { to: '/admin/perfis',                   label: 'Perfis de Usuário' },
      { to: '/admin/fiscal/tipos-movimento',   label: 'Tipos de Movimento' },
      { to: '/admin/notas-tecnicas',           label: 'Notas Técnicas SEFAZ' },
      { to: '/admin/locais-estoque',           label: 'Locais de Estoque' },
      { to: '/admin/importador',               label: 'Importar Dados' },
      { to: '/admin/auditoria',                label: 'Auditoria' },
    ],
  },
];

// Telas dos módulos liberados por organização (backend:
// config/modulosOrganizacao.js). Bloqueadas pra quem não é o suporte quando
// a organização não tem o módulo ligado — vale até pra admin.
export const MODULOS_ORG = {
  '/catalogo-online':        'catalogo_online',
  '/mercadopago':            'mercadopago',
  '/instagram':              'instagram',
  '/falar-suporte':          'falar_suporte',
  '/assistente-ia':          'assistente_ia',
  '/admin/notas-tecnicas':   'notas_tecnicas',
  '/admin/auditoria':        'auditoria',
  '/admin/importador':       'importador',
  '/vendas/pesagem':         'pesagem_etiquetas',
};

// Sem permissões carregadas ainda, os módulos restritos ficam escondidos
// (evita piscar no menu antes da resposta).
export function moduloBloqueado(perms, path) {
  const chave = Object.entries(MODULOS_ORG).find(([p]) => path === p || path.startsWith(p + '/'))?.[1];
  if (!chave) return false;
  if (!perms?.modulos_bloqueados) return !perms;
  return perms.modulos_bloqueados.includes(chave);
}

// ── Helpers de permissão (usados pelo Sidebar, TabWatcher e guarda do PDV) ──

// O caminho é permitido para estas permissões? Regras:
//  - admin ou '*' → tudo; submenu exige o menu pai marcado + o próprio path;
//  - caminho que só casa pelo prefixo do grupo (ex: telas internas) exige o menu;
//  - caminho fora do catálogo não é bloqueado (não é tela de menu).
export function pathPermitido(perms, path) {
  if (!perms) return false;
  if (moduloBloqueado(perms, path)) return false;
  if (perms.admin || (perms.menus || []).includes('*')) return true;
  const menus = perms.menus || [];
  const subs  = perms.submenus || [];

  const simples = ITENS_SIMPLES.find(i => i.to === path);
  if (simples) return menus.includes(simples.id);

  for (const g of GRUPOS) {
    if (g.filhos.some(f => f.to === path))
      return menus.includes(g.id) && (subs.includes('*') || subs.includes(path));
  }
  const porPrefixo = GRUPOS.find(g => g.prefixo.some(p => path.startsWith(p)));
  if (porPrefixo) return menus.includes(porPrefixo.id);
  return true;
}

// Primeira rota que o perfil pode abrir (destino de redirecionamento)
export function primeiraRotaPermitida(perms) {
  for (const i of ITENS_SIMPLES) if (pathPermitido(perms, i.to)) return i.to;
  for (const g of GRUPOS)
    for (const f of g.filhos)
      if (pathPermitido(perms, f.to)) return f.to;
  return '/dashboard';
}
